import { render, staticRenderFns } from "./RollNum.vue?vue&type=template&id=6d157e04&scoped=true&"
import script from "./RollNum.vue?vue&type=script&lang=js&"
export * from "./RollNum.vue?vue&type=script&lang=js&"
import style0 from "./RollNum.vue?vue&type=style&index=0&id=6d157e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d157e04",
  null
  
)

export default component.exports